import { useEffect, useRef, useState } from "react";
import LocationList from '../Components/Location';
import EmployeeList from '../Components/Employee';
import API from '../Services/ManagerCard'
import { ToastContainer, toast } from "react-toastify";
import MangerCardList from "../Components/ManagerCardList";

const ManagerCard = () => {
    const [locationId, setLocationId] = useState("");
    const [employeeId, setEmployeeId] = useState("");
    const inputRef = useRef(null);
    const [cardNo, setCardNo] = useState("");
    const [userInfo, setUserInfo] = useState("");
    const [scanFirst, setScanFirst] = useState("");


    useEffect(() => {
        inputRef.current?.focus();
    }, []);


    const handleCardNo = (e) => {
        const value = e.target.value;
        const numericOnly = value.replace(/\D/g, '');
        setCardNo(numericOnly.slice(0, 11));
    };


    const createManagerData = async () => {
        if (!employeeId || !cardNo) {
            setScanFirst(true);
            toast.error("Please select a manager and scan the card.");
            return;
        }
        const payload = {
            emp_id: parseInt(employeeId),
            card_no: cardNo,
        };
        try {
            const response = await API.createManager(payload);
            //console.log("response data....", response?.data?.result);
            if (response?.status === 200) {
                toast.success(response?.data?.message || "Manager assigned successfully!");
                setCardNo("");
                setScanFirst(false);
                setUserInfo("Assigned");
                inputRef.current?.focus();
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Manager assignment failed.");
            }
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                const errorMessage = error.response.data?.message || `Error: ${status}`;

                if (status === 403) {
                    window.location.replace("/Login");
                } else if (status === 404) {
                    toast.error("Resource not found.");
                } else {
                    toast.error(errorMessage);
                }
            } else if (error.request) {
                console.error("Request error:", error.request);
                toast.error("No response from server. Please try again later.");
            } else {
                console.error("Error message:", error.message);
                toast.error("Something went wrong. Please try again.");
            }
        }
    };

    return (
        <div>
            <div className="col-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">Manager Card</h4>
                        <div className="forms-sample">
                            <div className="row">
                                <div className="col-md-4">
                                    <LocationList
                                        selectedLocation={locationId}
                                        setSelectedLocation={setLocationId}
                                    />
                                </div>
                                <div className="col-md-4">

                                    <EmployeeList
                                        selectedEmployee={employeeId}
                                        setSelectedEmployee={setEmployeeId}
                                        label="Manager"
                                    />
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="cardScan">
                                            Scan Card <span style={{ color: "red" }}>*</span>
                                        </label>
                                        {/* {!userInfo && ( */}
                                        <input
                                            id="cardScan"
                                            type="text"
                                            placeholder="Scan Card"
                                            value={cardNo}
                                            ref={inputRef}
                                            // disabled={userInfo}
                                            className={`form-control ${scanFirst && !cardNo ? "border-danger" : ""}`}
                                            onChange={handleCardNo}
                                        />
                                        {/* )} */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-3">
                            <button
                                onClick={createManagerData}
                                type="button"
                                className="btn btn-primary me-3">
                                Submit
                            </button>
                            <button className="btn btn-light">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
            <MangerCardList />
        </div>
    );
};

export default ManagerCard;
